import { isLocalMachine } from "../../utils/api/controlProxy";

/**
 * Returns the endpoint URL for fnp cash balance.
 *
 * @param {object} params - The parameters to be sent with the request.
 * @param {string} params.isAgent - Whether the request is from an agent.
 * @param {string} params.partyId - The party ID.
 * @returns {string} The endpoint URL for fnp cash balance.
 */
export const getFnpCashBalanceEndpoint = (params) => {
  const { isAgent, partyId } = params || {};
  const baseUrl = isLocalMachine() ? "/control" : "/d/control";
  return `${baseUrl}/gwb${isAgent === "true" || isAgent === true ? `?partyId=${partyId}&isAgent=Y` : ""}`;
};

/**
 * Returns the endpoint URL for fnp cash label.
 */
export const getFnpCashLabelSystemProperty = () => {
  return "/control/getSystemPropertyValue?resource=fnp&name=WALLET_INFO";
};
